export default ({ str = '', isLowerCase = true }) =>
  isLowerCase
    ? str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
    : str.replace(/([a-z])([A-Z])/g, '$1-$2');
